'use client'

import React, { useState, useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import {
    FormField,
    FormItem,
    FormControl,
    FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { HelpCircle, RotateCcw } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Label } from "@/components/ui/label";
import { packagingData } from '@/lib/utils';
interface SecondaryPackageDetailsProps {
    form: UseFormReturn<any>;
    request?: {
        primary_package_diameter?: number | string;
        primary_package_diameter_unit?: string;
        primary_package_height?: number | string;
        primary_package_height_unit?: string;
        items_per_case?: string;
    };
}
const convertWeight = (value: number, fromUnit: string, toUnit: string): number => {
    // First convert to grams as base unit
    let valueInGrams = value;
    switch (fromUnit) {
        case 'lbs':
            valueInGrams = value * 453.592;
            break;
        case 'oz':
            valueInGrams = value * 28.3495;
            break;
        case 'kg':
            valueInGrams = value * 1000;
            break;
        case 'g':
            valueInGrams = value;
            break;
    }

    // Then convert from grams to target unit
    switch (toUnit) {
        case 'lbs':
            return valueInGrams / 453.592;
        case 'oz':
            return valueInGrams / 28.3495;
        case 'kg':
            return valueInGrams / 1000;
        case 'g':
            return valueInGrams;
        default:
            return value;
    }
};

const secondaryPackageTypeOptions = [
    "Shrink", "Shell", "Tray", "Shrink W Tray", "PAD", "TRAY & CASE", "Case",
    "CASE/Shell", "Shrink W Pad",  "Wrap", "Paperboard Wrap", "case/pack",
    "RSW", "RSW +Pad", "Tray -Shrink", "Corrugated Case", "Others", 'Paperboard'
];
const lbsUnits = ["lbs", "oz", 'g', 'kg']
const inUnits = ["inch", "mm"]

const packageTypeFactor = {
    "Shell": { length: 1.6, width: 0.94, height: 0.62 },
    "Case": { length: 0.49, width: 0.52, height: 0.36 },
    "Corrugated": { length: 0.49, width: 0.52, height: 0.36 },
    "Corrugated Case": { length: 0.49, width: 0.52, height: 0.36 },
    "Paperboard Wrap": { length: 0.25, width: 0.09, height: 0.05 },
    "Paperboard": { length: 0.25, width: 0.09, height: 0.05 },
    "Shrink": { length: -0.28, width: -0.17, height: 0.29 },
    "Shrink Bundle": { length: -0.28, width: -0.17, height: 0.29 },
    "Shrink W Pad": { length: -0.31, width: -0.2, height: 0.87 },
    "Shrink W Tray": { length: -0.05, width: 0.06, height: 0.61 },
    "Tray -Shrink": { length: -0.05, width: 0.06, height: 0.61 },
    "TRAY & CASE": { length: 0.28, width: 0.17, height: 0.5 },
    "Tray": { length: 0.1, width: 0.1, height: 0.54 },
    "Wrap": { length: -2.2, width: 1.5, height: 0.3 },
    "PAD": { length: -0.35, width: -0.28, height: 0.66 },
    "case/pack": { length: 0.29, width: 0.15, height: 0.22 },
    "RSW": { length: -0.31, width: -0.2, height: 0.87 },
    "RSW +Pad": { length: -0.31, width: -0.2, height: 0.87 },
    "Base": { length: 0.8, width: 0.8, height: 0.3 },
    "Others": { length: 0.8, width: 0.8, height: 0.3 },
    "CASE/Shell": { length: 1.6, width: 0.9, height: 0.3 }
};

const SecondaryPackageDetails: React.FC<SecondaryPackageDetailsProps> = ({ form, request }) => {
    // const [isLengthAutoCalculated, setIsLengthAutoCalculated] = useState(form.getValues('isSecondaryLengthAutoCalculated') || true);
    // const [isWidthAutoCalculated, setIsWidthAutoCalculated] = useState(form.getValues('isSecondaryWidthAutoCalculated') || true);
    // const [isHeightAutoCalculated, setIsHeightAutoCalculated] = useState(form.getValues('isSecondaryHeightAutoCalculated') || true);
    // console.log(isLengthAutoCalculated,isWidthAutoCalculated,isHeightAutoCalculated,'trues',request?.isSecondaryHeightAutoCalculated,request?.isSecondaryWidthAutoCalculated,request?.isSecondaryLengthAutoCalculated,form.getValues())
    // useEffect(()=>{
    //     form.setValue('isSecondaryLengthAutoCalculated',isLengthAutoCalculated)
    // },[isLengthAutoCalculated])

    // useEffect(()=>{
    //     form.setValue('isSecondaryWidthAutoCalculated',isWidthAutoCalculated)
    // },[isWidthAutoCalculated])
    // useEffect(()=>{
    //     form.setValue('isSecondaryHeightAutoCalculated',isHeightAutoCalculated)
    // },[isHeightAutoCalculated])
    console.log(request, form.getValues(), 'trues')
    const convertLength = (value: number, fromUnit: string, toUnit: string): number => {
        // Convert to inches first (1 mm = 0.0393701 inches)
        const valueInInches = fromUnit === 'mm' ? value * 0.0393701 : value;
        // Then convert to target unit
        return toUnit === 'mm' ? valueInInches / 0.0393701 : valueInInches;
    };

    const safeNumberConvert = (value: any): number => {
        console.log(value, 'value in safe number');
        if (value === undefined || value === null || value === '') return 0;
        const num = typeof value === 'string' ? Number(value) : value;
        return isNaN(num) ? 0 : num;
    };

    const safeToFixed = (value: any, decimals: number = 2): string => {
        const num = safeNumberConvert(value);
        return num.toFixed(decimals);
    };

    const calculateSecondaryDimension = (dimension: 'length' | 'width' | 'height'): number => {
        const packageType = form.getValues('secondary_package_type');
        const primaryDiameter = safeNumberConvert(request?.primary_package_diameter);
        const primaryDiameterUnit = request?.primary_package_diameter_unit || 'inch';
        const packageHeight = safeNumberConvert(request?.primary_package_height);
        const packageHeightUnit = request?.primary_package_height_unit || 'inch';
        const itemsPerCase = request?.items_per_case;

        console.log('Calculation inputs:', {
            packageType,
            primaryDiameter,
            primaryDiameterUnit,
            packageHeight,
            packageHeightUnit,
            itemsPerCase
        });

        if (!packageType || !primaryDiameter || !packageHeight || !itemsPerCase) {
            console.warn('Missing required inputs for calculation');
            return 0;
        }

        const factor = packageTypeFactor[packageType as keyof typeof packageTypeFactor];
        console.log('Package type factor:', factor);

        if (!factor) {
            console.warn('No factor found for package type');
            return 0;
        }

        const [totalItems, layout] = itemsPerCase.split(' ');
        const [rows, columns] = layout.slice(1, -1).split(/[x×]/i).map(safeNumberConvert);
        console.log('Layout details:', { totalItems, rows, columns });

        // Convert dimensions to inches if in mm
        const diameterInInches = primaryDiameterUnit === 'mm' ? primaryDiameter / 25.4 : primaryDiameter;
        const heightInInches = packageHeightUnit === 'mm' ? packageHeight / 25.4 : packageHeight;

        console.log('Converted dimensions:', {
            diameterInInches,
            heightInInches
        });

        switch (dimension) {
            case 'length':
                const lengthCalc = rows * diameterInInches + factor.length;
                console.log('Length calculation:', `${rows} * ${diameterInInches} + ${factor.length} = ${lengthCalc}`);
                return lengthCalc;
            case 'width':
                const widthCalc = columns * diameterInInches + factor.width;
                console.log('Width calculation:', `${columns} * ${diameterInInches} + ${factor.width} = ${widthCalc}`);
                return widthCalc;
            case 'height':
                const heightCalc = heightInInches + factor.height;
                console.log('Height calculation:', `${heightInInches} + ${factor.height} = ${heightCalc}`);
                return heightCalc;
            default:
                return 0;
        }
    };

    // Add useEffect to auto-calculate on page load and when dependencies change
    useEffect(() => {
        if (form.getValues('isSecondaryLengthAutoCalculated')) {
            const calculatedLength = calculateSecondaryDimension('length');
            const unit = form.getValues('secondary_length_unit') || 'in';
            const convertedLength = convertLength(calculatedLength, 'in', unit);
            form.setValue('secondary_length', safeToFixed(convertedLength), {
                shouldValidate: true,
                shouldDirty: true
            });
            console.log('Auto-calculated length:', convertedLength);
        }
    }, [
        form.getValues('secondary_package_type'),
        request?.primary_package_diameter,
        request?.primary_package_diameter_unit,
        request?.items_per_case,
        form.getValues('isSecondaryLengthAutoCalculated')
    ]);

    useEffect(() => {
        if (form.getValues('isSecondaryWidthAutoCalculated')) {
            const calculatedWidth = calculateSecondaryDimension('width');
            const unit = form.getValues('secondary_width_unit') || 'in';
            const convertedWidth = convertLength(calculatedWidth, 'in', unit);
            form.setValue('secondary_width', safeToFixed(convertedWidth), {
                shouldValidate: true,
                shouldDirty: true
            });
            console.log('Auto-calculated width:', convertedWidth);
        }
    }, [
        form.getValues('secondary_package_type'),
        request?.primary_package_diameter,
        request?.primary_package_diameter_unit,
        request?.items_per_case,
        form.getValues('isSecondaryWidthAutoCalculated')
    ]);

    useEffect(() => {
        if (form.getValues('isSecondaryHeightAutoCalculated')) {
            const calculatedHeight = calculateSecondaryDimension('height');
            const unit = form.getValues('secondary_height_unit') || 'in';
            const convertedHeight = convertLength(calculatedHeight, 'in', unit);
            form.setValue('secondary_height', safeToFixed(convertedHeight), {
                shouldValidate: true,
                shouldDirty: true
            });
            console.log('Auto-calculated height:', convertedHeight);
        }
    }, [
        form.getValues('secondary_package_type'),
        request?.primary_package_height,
        request?.primary_package_height_unit,
        form.getValues('isSecondaryHeightAutoCalculated')
    ]);
    const calculateSecondaryPackageGrossWeight = () => {
        const calculateFilledWeight = (netContent, netContentUnit, category) => {


            // If any of the required values are missing, return 0
            if (!netContent || !netContentUnit || !category) return 0;

            // Convert netContent to ml if unit is oz
            const netContentMl = netContentUnit === 'oz' ? netContent * 29.5735 : netContent;

            // Define density values for different categories
            const density: { [key: string]: number } = {
                'CSD': 1.016,
                'SF': 1.027,
                'Coffee Partnership': 1.031,
                'Tea': 1.031,
                'Hydration': 1,
                'juice plus': 1.15
            };

            // Get the density for the given category, defaulting to 1 if not found
            const categoryDensity = density[category] || 1;

            // Calculate the empty bottle weight (you can replace this with actual logic)
            const emptyBottleWeight = 50; // Placeholder, adjust based on your own logic

            // Calculate the filled weight in grams
            const filledWeightGrams = (netContentMl * categoryDensity) + emptyBottleWeight;

            // Convert the weight to pounds (1 gram = 0.00220462 pounds)
            const filledWeightPounds = filledWeightGrams * 0.00220462;

            // Return the filled weight in pounds
            return filledWeightPounds;
        };
        const filledWeight = calculateFilledWeight(request?.net_contents, request?.net_contents_unit, request?.category)
        const filledWeightUnit = "lbs"
        const secondaryPackageCase = request?.items_per_case;

        if (!filledWeight || !filledWeightUnit || !secondaryPackageCase) return 0;

        // Convert filled weight to pounds based on unit
        const filledWeightInPounds = filledWeight;
        // switch (filledWeightUnit) {
        //   case 'oz':
        //     filledWeightInPounds = filledWeight / 16; // 16 oz = 1 lb
        //     break;
        //   case 'g':
        //     filledWeightInPounds = filledWeight / 453.592; // 453.592 g = 1 lb
        //     break;
        //   case 'kg':
        //     filledWeightInPounds = filledWeight * 2.20462; // 1 kg = 2.20462 lbs
        //     break;
        //   case 'lbs':
        //   default:
        //     break;
        // }

        const itemsPerCase = safeNumberConvert(secondaryPackageCase.split(' ')[0]);
        const caseLength = form.getValues('secondary_length')
        const caseLengthUnit = form.getValues('secondary_length_unit')
        const caseWidth = form.getValues('secondary_width')
        const caseWidthUnit = form.getValues('secondary_width_unit')
        const caseHeight = form.getValues('secondary_height')
        const caseHeightUnit = form.getValues('secondary_height_unit')
        const caseLengthInInches = convertLength(caseLength, caseLengthUnit, 'in')
        const caseWidthInInches = convertLength(caseWidth, caseWidthUnit, 'in')
        const caseHeightInInches = convertLength(caseHeight, caseHeightUnit, 'in')
        const secondaryPackageType = form.getValues('secondary_package_type')
        let surfaceArea = 0
        if (secondaryPackageType === 'Wrap' || secondaryPackageType === 'PAD' || secondaryPackageType === 'case/pack' || secondaryPackageType === 'Base' || secondaryPackageType === 'CASE/Shell') {
            surfaceArea = 2 * ((caseLengthInInches * caseWidthInInches) + (caseLengthInInches * caseHeightInInches) + (caseWidthInInches * caseHeightInInches)) * 0.00064516
        } else if (secondaryPackageType === 'Tray' || secondaryPackageType === 'TRAY & CASE' || secondaryPackageType === 'Shrink W Tray' || secondaryPackageType === 'Tray -Shrink') {
            surfaceArea = ((caseLengthInInches * caseWidthInInches) + 2 * (caseLengthInInches * caseHeightInInches) + 2 * (caseWidthInInches * caseHeightInInches)) * 0.00064516
        } else if (secondaryPackageType === 'RSW +Pad' || secondaryPackageType === 'Shrink' || secondaryPackageType === 'Shrink W Pad' || secondaryPackageType === 'RSW' || secondaryPackageType === 'Paperboard' || secondaryPackageType === 'Corrugated' || secondaryPackageType === 'Corrugated Case' || secondaryPackageType === 'Paperboard Wrap' || secondaryPackageType === 'Case') {
            surfaceArea = 2 * ((caseLengthInInches * caseWidthInInches) + (caseLengthInInches * caseHeightInInches) + (caseWidthInInches * caseHeightInInches)) * 0.00064516
        } else {
            surfaceArea = ((caseLengthInInches * caseWidthInInches) + 2 * (caseLengthInInches * caseHeightInInches) + 2 * (caseWidthInInches * caseHeightInInches)) * 0.00064516
        }

        console.log(secondaryPackageType, 'secondaryPackageTypeee', packagingData.find((item) => item.packagingType === secondaryPackageType)?.materialGSM)
        const materialGSM = packagingData.find((item) => item.packagingType === secondaryPackageType)?.materialGSM
        const weightOfEmptyPackage = surfaceArea * materialGSM * 0.00220462
        console.log('caseLengthInInches', caseLengthInInches)
        console.log('caseWidthInInches', caseWidthInInches)
        console.log('caseHeightInInches', caseHeightInInches)
        console.log('surfaceArea', surfaceArea.toFixed(2))
        console.log('materialGSM', materialGSM)
        console.log(weightOfEmptyPackage, 'weightOfEmptyPackage')
        return (filledWeightInPounds * itemsPerCase) + weightOfEmptyPackage;
    };
    // Add watchers for the fields that drive secondary gross weight calculation
    const secondaryPackageTypeWatch = form.watch('secondary_package_type');
    const secondaryLengthWatch = form.watch('secondary_length');
    const secondaryWidthWatch = form.watch('secondary_width');
    const secondaryHeightWatch = form.watch('secondary_height');
    const secondaryWeightUnitWatch = form.watch('secondary_weight_unit');
    const isSecondaryWeightAutoCalculatedWatch = form.watch('isSecondaryWeightAutoCalculated');
    useEffect(() => {
        const secondaryGrossWeight = calculateSecondaryPackageGrossWeight();
        console.log(secondaryGrossWeight, 'secondaryGrossWeight')
        const secondaryGrossWeightUnit = form.getValues('secondary_weight_unit') || 'lbs';
        const convertedGrossWeight = convertWeight(secondaryGrossWeight, 'lbs', secondaryGrossWeightUnit);
        if (form.getValues('isSecondaryWeightAutoCalculated')) {
            form.setValue('secondary_weight', safeToFixed(convertedGrossWeight));
        }
    }, [
        secondaryPackageTypeWatch,
        secondaryLengthWatch,
        secondaryWidthWatch,
        secondaryHeightWatch,
        secondaryWeightUnitWatch,
        isSecondaryWeightAutoCalculatedWatch
    ])
    return (
        <div>
            {/* Header Row */}
            <div className="flex-center border-border-style-1 border w-full">
                <div className="label-bg">
                    <Label className="label font-bold">Secondary Package Details</Label>
                </div>
            </div>

            {/* First Row */}
            <div className="flex w-full border-x border-b">
                <div className="flex-1 p-4">
                    <div className="flex flex-col">
                        <div className="flex items-center gap-2 mb-2">
                            <Label className="label font-bold">Secondary Package Type*</Label>
                            <TooltipProvider>
                                <Tooltip>
                                    <TooltipTrigger type='button'>
                                        <HelpCircle className="h-4 w-4 text-muted-foreground" />
                                    </TooltipTrigger>
                                    <TooltipContent>
                                        <p>Secondary Package Type help text</p>
                                    </TooltipContent>
                                </Tooltip>
                            </TooltipProvider>
                        </div>
                        <FormField
                            control={form.control}
                            name="secondary_package_type"
                            render={({ field }) => (
                                <FormItem>
                                    <Select
                                        onValueChange={field.onChange}
                                        defaultValue={field.value}
                                    >
                                        <FormControl>
                                            <SelectTrigger className="bg-selectBlue border-required border-2">
                                                <SelectValue placeholder="Select package type" />
                                            </SelectTrigger>
                                        </FormControl>
                                        <SelectContent>
                                            {secondaryPackageTypeOptions.map((type) => (
                                                <SelectItem key={type} value={type}>
                                                    {type}
                                                </SelectItem>
                                            ))}
                                        </SelectContent>
                                    </Select>
                                    <FormMessage />
                                </FormItem>
                            )}
                        />
                    </div>
                </div>

                <div className="flex-1 p-4">
                    <div className="flex flex-col">
                        <div className="flex items-center gap-2 mb-2">
                            <Label className="label font-bold">Topload-Filled Case</Label>
                            <TooltipProvider>
                                <Tooltip>
                                    <TooltipTrigger type='button'>
                                        <HelpCircle className="h-4 w-4 text-muted-foreground" />
                                    </TooltipTrigger>
                                    <TooltipContent>
                                        <p>Topload-Filled Case help text</p>
                                    </TooltipContent>
                                </Tooltip>
                            </TooltipProvider>
                        </div>
                        <div className="flex gap-2">
                            <FormField
                                control={form.control}
                                name="secondary_topload_filled"
                                render={({ field }) => (
                                    <FormItem className="flex-1">
                                        <FormControl>
                                            <Input type="number" placeholder="Enter value" {...field} className="bg-white" />
                                        </FormControl>
                                        <FormMessage />
                                    </FormItem>
                                )}
                            />
                            <Select
                                value={form.watch('secondary_topload_filled_unit')}
                                onValueChange={(value) => form.setValue('secondary_topload_filled_unit', value)}
                            >
                                <SelectTrigger className="w-[80px] bg-unitSelect rounded-[11px] py-3 text-white">
                                    <SelectValue defaultValue="lbf" />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="lbf">lbf</SelectItem>
                                </SelectContent>
                            </Select>
                        </div>
                    </div>
                </div>

                <div className="flex-1 p-4">
                    <div className="flex flex-col">
                        <div className="flex items-center gap-2 mb-2">
                            <Label className="label font-bold">Weight*</Label>
                            <div className="flex items-center gap-1">
                                {!form.getValues('isSecondaryWeightAutoCalculated') && (
                                    <TooltipProvider>
                                        <Tooltip>
                                            <TooltipTrigger asChild>
                                                <button
                                                    type="button"
                                                    title="Reset to auto-calculated value"
                                                    onClick={() => {
                                                        const calculatedValue = calculateSecondaryPackageGrossWeight();

                                                        form.setValue('secondary_weight', safeToFixed(calculatedValue), {
                                                            shouldValidate: true,
                                                            shouldDirty: true
                                                        });
                                                        form.setValue('isSecondaryWeightAutoCalculated', true);
                                                    }}
                                                    className="p-1 hover:bg-gray-100 rounded-full"
                                                >
                                                    <RotateCcw className="h-3 w-3 text-gray-500" />
                                                </button>
                                            </TooltipTrigger>
                                            <TooltipContent>
                                                <p>Reset to auto-calculated value</p>
                                            </TooltipContent>
                                        </Tooltip>
                                    </TooltipProvider>
                                )}
                                <TooltipProvider>
                                    <Tooltip>
                                        <TooltipTrigger type='button'>
                                            <HelpCircle className="h-4 w-4 text-muted-foreground" />
                                        </TooltipTrigger>
                                        <TooltipContent>
                                            <p>Formula: Net content in OZ * 0.0625 * Items/Case</p>
                                        </TooltipContent>
                                    </Tooltip>
                                </TooltipProvider>
                            </div>
                            <TooltipProvider>
                                <Tooltip>
                                    <TooltipTrigger type='button'>
                                        <HelpCircle className="h-4 w-4 text-muted-foreground" />
                                    </TooltipTrigger>
                                    <TooltipContent>
                                        <p>Weight help text</p>
                                    </TooltipContent>
                                </Tooltip>
                            </TooltipProvider>
                        </div>
                        <div className="flex gap-2">
                            <FormField
                                control={form.control}
                                name="secondary_weight"
                                render={({ field }) => (
                                    <FormItem className="flex-1">
                                        <FormControl>
                                            <Input type="number" placeholder="Enter value" {...field}
                                                onChange={(e) => {
                                                    field.onChange(e);
                                                    form.setValue('isSecondaryWeightAutoCalculated', false);
                                                }}
                                                className={` border-required border-2 ${form.getValues('isSecondaryWeightAutoCalculated') ? 'bg-bgYellow' : ''}`}
                                            />
                                        </FormControl>
                                        <FormMessage />
                                    </FormItem>
                                )}
                            />
                            <Select
                                value={form.watch('secondary_weight_unit')}
                                onValueChange={(value) => form.setValue('secondary_weight_unit', value)}
                            >
                                <SelectTrigger className="w-[80px] bg-unitSelect rounded-[11px] py-3 text-white">
                                    <SelectValue defaultValue="g" />
                                </SelectTrigger>
                                <SelectContent>
                                    {
                                        lbsUnits.map((unit) => (
                                            <SelectItem key={unit} value={unit}>{unit}</SelectItem>
                                        ))
                                    }
                                </SelectContent>
                            </Select>
                        </div>
                    </div>
                </div>

                <div className="flex-1 p-4">
                    <div className="flex flex-col">
                        <div className="flex items-center gap-2 mb-2">
                            <Label className="label font-bold">Length*</Label>
                            <div className="flex items-center gap-1">
                                {!form.getValues('isSecondaryLengthAutoCalculated') && (
                                    <TooltipProvider>
                                        <Tooltip>
                                            <TooltipTrigger asChild>
                                                <button
                                                    type="button"
                                                    title="Reset to auto-calculated value"
                                                    onClick={() => {
                                                        const calculatedValue = calculateSecondaryDimension('length');
                                                        const unit = form.getValues('secondary_length_unit') || 'in';
                                                        const convertedValue = convertLength(calculatedValue, 'in', unit);
                                                        form.setValue('secondary_length', safeToFixed(convertedValue), {
                                                            shouldValidate: true,
                                                            shouldDirty: true
                                                        });
                                                        form.setValue('isSecondaryLengthAutoCalculated', true);
                                                    }}
                                                    className="p-1 hover:bg-gray-100 rounded-full"
                                                >
                                                    <RotateCcw className="h-3 w-3 text-gray-500" />
                                                </button>
                                            </TooltipTrigger>
                                            <TooltipContent>
                                                <p>Reset to auto-calculated value</p>
                                            </TooltipContent>
                                        </Tooltip>
                                    </TooltipProvider>
                                )}
                                <TooltipProvider>
                                    <Tooltip>
                                        <TooltipTrigger type='button'>
                                            <HelpCircle className="h-4 w-4 text-muted-foreground" />
                                        </TooltipTrigger>
                                        <TooltipContent>
                                            <p>Formula: Rows in items per case * Diameter(in) + Secondary package type contribution</p>
                                        </TooltipContent>
                                    </Tooltip>
                                </TooltipProvider>
                            </div>
                        </div>
                        <div className="flex gap-2">
                            <FormField
                                control={form.control}
                                name="secondary_length"
                                render={({ field }) => (
                                    <FormItem className="flex-1">
                                        <FormControl>
                                            <Input
                                                type="number"
                                                placeholder="Enter value"
                                                {...field}
                                                onChange={(e) => {
                                                    field.onChange(e);
                                                    form.setValue('isSecondaryLengthAutoCalculated', false);
                                                }}
                                                className={` border-required border-2 ${form.getValues('isSecondaryLengthAutoCalculated') ? 'bg-bgYellow' : ''}`}
                                            />
                                        </FormControl>
                                        <FormMessage />
                                    </FormItem>
                                )}
                            />
                            <Select
                                value={form.watch('secondary_length_unit')}
                                onValueChange={(value) => {
                                    const currentValue = safeNumberConvert(form.getValues('secondary_length'));
                                    const currentUnit = form.getValues('secondary_length_unit');
                                    const convertedValue = convertLength(currentValue, currentUnit || 'in', value);
                                    form.setValue('secondary_length', safeToFixed(convertedValue), {
                                        shouldValidate: true,
                                        shouldDirty: true
                                    });
                                    form.setValue('secondary_length_unit', value);
                                }}
                            >
                                <SelectTrigger className="w-[80px] bg-unitSelect rounded-[11px] py-3 text-white">
                                    <SelectValue defaultValue="in" />
                                </SelectTrigger>
                                <SelectContent>
                                    {inUnits.map((unit) => (
                                        <SelectItem key={unit} value={unit}>{unit}</SelectItem>
                                    ))}
                                </SelectContent>
                            </Select>
                        </div>
                    </div>
                </div>
            </div>

            {/* Second Row */}
            <div className="flex w-full border-x border-b">
                <div className="flex-1 p-4">
                    <div className="flex flex-col">
                        <div className="flex items-center gap-2 mb-2">
                            <Label className="label font-bold">Width*</Label>
                            <div className="flex items-center gap-1">
                                {!form.getValues('isSecondaryWidthAutoCalculated') && (
                                    <TooltipProvider>
                                        <Tooltip>
                                            <TooltipTrigger asChild>
                                                <button
                                                    type="button"
                                                    title="Reset to auto-calculated value"
                                                    onClick={() => {
                                                        const calculatedValue = calculateSecondaryDimension('width');
                                                        console.log(calculatedValue, 'calculatedValue');
                                                        const unit = form.getValues('secondary_width_unit') || 'in';
                                                        const convertedValue = convertLength(calculatedValue, 'in', unit);
                                                        form.setValue('secondary_width', safeToFixed(convertedValue), {
                                                            shouldValidate: true,
                                                            shouldDirty: true
                                                        });
                                                        form.setValue('isSecondaryWidthAutoCalculated', true);
                                                    }}
                                                    className="p-1 hover:bg-gray-100 rounded-full"
                                                >
                                                    <RotateCcw className="h-3 w-3 text-gray-500" />
                                                </button>
                                            </TooltipTrigger>
                                            <TooltipContent>
                                                <p>Reset to auto-calculated value</p>
                                            </TooltipContent>
                                        </Tooltip>
                                    </TooltipProvider>
                                )}
                                <TooltipProvider>
                                    <Tooltip>
                                        <TooltipTrigger type='button'>
                                            <HelpCircle className="h-4 w-4 text-muted-foreground" />
                                        </TooltipTrigger>
                                        <TooltipContent>
                                            <p>Formula: Columns in items per case * Diameter(in) + Secondary package type factor</p>
                                        </TooltipContent>
                                    </Tooltip>
                                </TooltipProvider>
                            </div>
                        </div>
                        <div className="flex gap-2">
                            <FormField
                                control={form.control}
                                name="secondary_width"
                                render={({ field }) => (
                                    <FormItem className="flex-1">
                                        <FormControl>
                                            <Input
                                                type="number"
                                                placeholder="Enter value"
                                                {...field}
                                                onChange={(e) => {
                                                    field.onChange(e);
                                                    form.setValue('isSecondaryWidthAutoCalculated', false);
                                                }}
                                                className={` border-required border-2 ${form.getValues('isSecondaryWidthAutoCalculated') ? 'bg-bgYellow' : ''}`}
                                            />
                                        </FormControl>
                                        <FormMessage />
                                    </FormItem>
                                )}
                            />
                            <Select
                                value={form.watch('secondary_width_unit')}
                                onValueChange={(value) => {
                                    const currentValue = safeNumberConvert(form.getValues('secondary_width'));
                                    const currentUnit = form.getValues('secondary_width_unit');
                                    const convertedValue = convertLength(currentValue, currentUnit || 'in', value);
                                    form.setValue('secondary_width', safeToFixed(convertedValue), {
                                        shouldValidate: true,
                                        shouldDirty: true
                                    });
                                    form.setValue('secondary_width_unit', value);
                                }}
                            >
                                <SelectTrigger className="w-[80px] bg-unitSelect rounded-[11px] py-3 text-white">
                                    <SelectValue defaultValue="in" />
                                </SelectTrigger>
                                <SelectContent>
                                    {inUnits.map((unit) => (
                                        <SelectItem key={unit} value={unit}>{unit}</SelectItem>
                                    ))}
                                </SelectContent>
                            </Select>
                        </div>
                    </div>
                </div>

                <div className="flex-1 p-4">
                    <div className="flex flex-col">
                        <div className="flex items-center gap-2 mb-2">
                            <Label className="label font-bold">Height*</Label>
                            <div className="flex items-center gap-1">
                                {!form.getValues('isSecondaryHeightAutoCalculated') && (
                                    <TooltipProvider>
                                        <Tooltip>
                                            <TooltipTrigger asChild>
                                                <button
                                                    type="button"
                                                    title="Reset to auto-calculated value"
                                                    onClick={() => {
                                                        const calculatedValue = calculateSecondaryDimension('height');
                                                        const unit = form.getValues('secondary_height_unit') || 'in';
                                                        const convertedValue = convertLength(calculatedValue, 'in', unit);
                                                        form.setValue('secondary_height', safeToFixed(convertedValue), {
                                                            shouldValidate: true,
                                                            shouldDirty: true
                                                        });
                                                        form.setValue('isSecondaryHeightAutoCalculated', true);
                                                    }}
                                                    className="p-1 hover:bg-gray-100 rounded-full"
                                                >
                                                    <RotateCcw className="h-3 w-3 text-gray-500" />
                                                </button>
                                            </TooltipTrigger>
                                            <TooltipContent>
                                                <p>Reset to auto-calculated value</p>
                                            </TooltipContent>
                                        </Tooltip>
                                    </TooltipProvider>
                                )}
                                <TooltipProvider>
                                    <Tooltip>
                                        <TooltipTrigger type='button'>
                                            <HelpCircle className="h-4 w-4 text-muted-foreground" />
                                        </TooltipTrigger>
                                        <TooltipContent>
                                            <p>Formula: Package Height(in) + Secondary package type factor</p>
                                        </TooltipContent>
                                    </Tooltip>
                                </TooltipProvider>
                            </div>
                        </div>
                        <div className="flex gap-2">
                            <FormField
                                control={form.control}
                                name="secondary_height"
                                render={({ field }) => (
                                    <FormItem className="flex-1">
                                        <FormControl>
                                            <Input
                                                type="number"
                                                placeholder="Enter value"
                                                {...field}
                                                onChange={(e) => {
                                                    field.onChange(e);
                                                    form.setValue('isSecondaryHeightAutoCalculated', false);
                                                }}
                                                className={` border-required border-2 ${form.getValues('isSecondaryHeightAutoCalculated') ? 'bg-bgYellow' : ''}`}
                                            />
                                        </FormControl>
                                        <FormMessage />
                                    </FormItem>
                                )}
                            />
                            <Select
                                value={form.watch('secondary_height_unit')}
                                onValueChange={(value) => {
                                    const currentValue = safeNumberConvert(form.getValues('secondary_height'));
                                    const currentUnit = form.getValues('secondary_height_unit');
                                    const convertedValue = convertLength(currentValue, currentUnit || 'in', value);
                                    form.setValue('secondary_height', safeToFixed(convertedValue), {
                                        shouldValidate: true,
                                        shouldDirty: true
                                    });
                                    form.setValue('secondary_height_unit', value);
                                }}
                            >
                                <SelectTrigger className="w-[80px] bg-unitSelect rounded-[11px] py-3 text-white">
                                    <SelectValue defaultValue="in" />
                                </SelectTrigger>
                                <SelectContent>
                                    {inUnits.map((unit) => (
                                        <SelectItem key={unit} value={unit}>{unit}</SelectItem>
                                    ))}
                                </SelectContent>
                            </Select>
                        </div>
                    </div>
                </div>
                <div className="flex-1 p-4"></div>
                <div className="flex-1 p-4"></div>
            </div>

            <div className="mt-4 p-4 text-sm text-gray-500">
                <p>Cells highlighted in light yellow contain calculated values. Users can update these cells with actual values when necessary</p>
            </div>
        </div>
    );
};

export default SecondaryPackageDetails; 
